import { PathnamesMap } from '../constants/ui';
import type { TFunction } from 'i18next';
import { CropsIcon, DashboardIcon, FieldsIcon, MapsIcon, ScoringIcon, SettingsIcon, SoilIcon, TeamIcon } from './icons';

export const getSidebarLinksMap = (t: TFunction) => ({
  sensors: {
    Icon: DashboardIcon,
    title: t('nav.dashboard'),
    url: PathnamesMap.dashboard,
  },
  map: {
    Icon: MapsIcon,
    title: t('nav.map'),
    url: PathnamesMap.map,
  },
  crops: {
    Icon: CropsIcon,
    title: t('nav.crop'),
    titleMobile: t('nav.cropMobile'),
    description: t('nav.cropText'),
    url: PathnamesMap.crops,
  },
  scoring: {
    Icon: ScoringIcon,
    title: t('nav.scoring'),
    titleMobile: t('nav.scoringMobile'),
    description: t('nav.scoringText'),
    url: PathnamesMap.scoring,
  },
  fields: {
    Icon: FieldsIcon,
    title: t('nav.fields'),
    titleMobile: t('nav.fieldsMobile'),
    description: t('nav.fieldsText'),
    url: PathnamesMap.fields,
  },
  devices: {
    Icon: SettingsIcon,
    title: t('nav.devices'),
    url: PathnamesMap.devices,
  },
  team: {
    Icon: TeamIcon,
    title: t('nav.team'),
    url: PathnamesMap.team,
  },
  season: {
    title: t('nav.seasonAdd'),
    titleSecondary: t('nav.seasonSecondary'),
    descriptionEdit: t('nav.seasonEdit'),
    descriptionAdd: t('nav.createBoundary'),
    descriptionAddVarda: t('nav.pickBoundary'),
  },
  workspace: {
    title: t('nav.workspace'),
  },
  profile: {
    title: t('nav.profile'),
  },
  soilSensor: {
    Icon: SoilIcon,
    title: t('metrics.soilSensor'),
    url: PathnamesMap.soilSensor,
  },
});

export const getRoles = (t: TFunction): { value: string; name: string }[] => [
  {
    value: 'owner',
    name: t('roles.owner'),
  },
  {
    value: 'editor',
    name: t('roles.editor'),
  },
  {
    value: 'viewer',
    name: t('roles.viewer'),
  },
  {
    value: 'dealer',
    name: t('roles.dealer'),
  },
];

// Used for shorten months names in Timeline
export const getShortenMonths = (t: TFunction) => {
  return t('months', { returnObjects: true });
};

export const textColorByBg = ({ hex }: { hex?: string }): string | undefined => {
  if (!hex) return;

  let r = 0,
    g = 0,
    b = 0;

  // 3 digits
  if (hex.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);

    // 6 digits
  } else if (hex.length === 7) {
    r = parseInt(hex[1] + hex[2], 16);
    g = parseInt(hex[3] + hex[4], 16);
    b = parseInt(hex[5] + hex[6], 16);
  }

  return r * 0.299 + g * 0.587 + b * 0.114 > 145 ? '#000' : '#fff';
};

export const getFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase();
};

export const getSafeAreaInsetTop = (): number => {
  const value = getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-top');
  return parseInt(value) || 0;
};

export const setVh = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};
